import React, { FC } from 'react'

import LoadingSpinner from '@components/shared/LoadingSpinner'
import Collection from '@models/Collection'
import { CollectionCollectionItem, CollectionTitleItem } from '@models/CollectionItem'
import { PageStatus, usePageApi } from '@providers/PageApiProvider'
import { BrowsePageApiResponse } from '@providers/types/api-responses'

import { CollectionCollection } from './CollectionCollection'
import { CollectionTitles } from './CollectionTitles'

interface CollectionsProps {
  collections: Collection<CollectionTitleItem | CollectionCollectionItem>[]
}

/**
 * Parent container for scollable rows of Collections and Titles
 */
const Collections: FC<CollectionsProps> = ({ collections }: CollectionsProps): JSX.Element => {
  const { status } = usePageApi<BrowsePageApiResponse>()

  return (
    <div className="flex-1 px-4 pb-4 md:col-span-2 flex flex-col">
      {!collections && status === PageStatus.LOADING ? (
        <LoadingSpinner />
      ) : (
        collections?.map((collection) => {
          if (collection.type === 'CollectionCollection') {
            return (
              <CollectionCollection
                collection={collection as Collection<CollectionCollectionItem>}
                key={collection.id}
              />
            )
          } else if (collection.type === 'CollectionContentTitle') {
            return (
              <CollectionTitles
                collection={collection as Collection<CollectionTitleItem>}
                key={collection.id}
              />
            )
          }
        })
      )}
    </div>
  )
}

export default Collections
